function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.2141 8.26266V18.0407H21.4463V16.3215H16.9333V8.26266H15.2141Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.9998 16.1033C31.9998 7.9099 25.3248 1.2459 17.1316 1.2459C9.78258 1.2459 3.66593 6.6509 2.48268 13.6352H0.0961914L4.21178 20.727L8.44793 13.6352H5.98096C7.10985 8.47757 11.6862 4.68433 17.1395 4.68433C23.4367 4.68433 28.5614 9.80684 28.5614 16.104C28.5614 21.5456 24.6697 26.1089 19.6195 27.2489V30.7541C26.6038 29.5707 31.9998 23.4521 31.9998 16.1033Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.62041 29.1997L3.71373 28.0374C4.42409 27.2643 4.91149 26.6857 5.17603 26.2936C5.44057 25.9014 5.57285 25.4523 5.57285 24.9417C5.57285 24.1832 5.32399 23.5869 4.82638 23.1501C4.32878 22.7138 3.63604 22.4956 2.74807 22.4956C1.91177 22.4956 1.24031 22.7561 0.733465 23.2757C0.226511 23.7956 -0.017725 24.4442 0.000864004 25.1915L0.0120389 25.2398H1.84343C1.84343 24.81 1.92392 24.5507 2.08488 24.3121C2.24584 24.0732 2.46687 23.9467 2.74817 23.9467C3.06257 23.9467 3.29843 24.0354 3.45563 24.2205C3.61294 24.4055 3.69149 24.6514 3.69149 24.9624C3.69149 25.1806 3.6138 25.4368 3.45842 25.7327C3.30305 26.0288 3.07901 26.365 2.75 26.7425L0.170959 29.4725V30.7199H5.75841V29.2156H2.63707L2.62041 29.1997Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.916 22.6611H9.08936V22.6296L5.828 27.8497L5.91869 29.0007H9.08936V30.7199H10.916V29.0007H11.7756V27.6039H10.916V22.6611ZM9.08936 27.6039H7.48382L8.87134 25.2953L9.03584 25.0525L9.08936 25.0494V27.6039Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9004 30.7199V27.2414C17.9004 26.9829 17.9069 26.7457 17.8783 26.5258C17.8058 25.9713 17.6555 25.5369 17.4014 25.2269C17.0461 24.794 16.5634 24.5776 15.9418 24.5776C15.6273 24.5776 15.3628 24.6525 15.1019 24.8024C14.841 24.9523 14.5694 25.1623 14.462 25.4324V22.5536H12.5278V30.7199H14.462V26.3257C14.462 26.2296 14.6413 26.1547 14.7746 26.1009C14.9077 26.0474 15.0548 26.0206 15.236 26.0206C15.521 26.0206 15.7299 26.1075 15.8686 26.2812C16.0074 26.4552 16.0737 26.7715 16.0737 27.2305V30.7199H16.727H17.9004Z",
  fill: "white"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.d8cc80e0.svg";
export { ForwardRef as ReactComponent };